import { Link } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../utils/toAbsoluteUrl';
import { translate } from '../../Internationalization';
import images from '../../../config/local/images';
import React from 'react';

const legendClass = 'h-ms-3 mb-6';
const text = translate('global.offers.vendor_exclusivity.vendor_exclusivity');

/**
 * @param {{isGated: boolean; isGettingData: boolean; subscriptionPath: string}} props
 * @returns {JSX.Element | string}
 */
function VendorExclusivityLabel(props) {
	if (!props.isGated || props.isGettingData) {
		return <legend className={legendClass}>{text}</legend>;
	}

	return (
		<legend className={legendClass}>
			<div className="flex items-center">
				{text}

				<Link
					className="w-3.5 ml-1"
					title="Click here to upgrade"
					to={props.subscriptionPath}
				>
					<img
						alt="Feature has been locked and requires a subscription"
						src={toAbsoluteUrl(images.icons.lock)}
					/>
				</Link>
			</div>
		</legend>
	);
}

export default React.memo(VendorExclusivityLabel);
